import { isValidPhoneNumber } from "react-phone-number-input";
import * as yup from "yup";

export const mortgageApplicationSchema = yup.object().shape({
  category: yup.string().nullable().required("Category is required"),

  lastName: yup.string().required("Last name is required"),
  firstName: yup.string().required("First name is required"),
  middleName: yup.string(),
  gender: yup.string().required("Gender is required"),
  dob: yup.string().required("Date of Birth is required").nullable(),
  email: yup.string().email().required("Email is required"),
  netSalary: yup.string().nullable().required("Net salary is required"),
  phone: yup
    .string()
    .required("Phone Number is required")
    .test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {
        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),
  maritalStatus: yup.string().required("Martial status is required"),
  employmentType: yup.string().required("Emolpyment type is required"),
  coLastName: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Last name is required"),
    otherwise: yup.string(),
  }),
  coFirstName: yup.string().when("category", {
    is: "joint",
    then: yup
      .string()
      // .notOneOf(
      //   [yup.ref("firstName"), null],
      //   "First name must be different from main applicant's first name"
      // )
      .required("First name is required"),
    otherwise: yup.string(),
  }),

  coMiddleName: yup.string().when("category", {
    is: "joint",
    then: yup.string(),
    otherwise: yup.string(),
  }),
  coGender: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Gender is required"),
    otherwise: yup.string(),
  }),
  coDob: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Date of Birth is required").nullable(),
    otherwise: yup.string().nullable(),
  }),
  coEmail: yup.string().when("category", {
    is: "joint",
    then: yup
      .string()
      .email("Email is not valid")
      .notOneOf(
        [yup.ref("email"), null],
        "Email must be different from main applicant's email"
      )
      .required("Email is required"),
    otherwise: yup.string(),
  }),
  coPhone: yup.string().when("category", {
    is: "joint",
    then: yup
      .string()
      
      .notOneOf(
        [yup.ref("phone"), null],
        "Phone number must be different from main applicant's phone number"
      )
      .required("Phone Number is required")
      .test({
        name: "valid",
        message: "Phone number must be valid",
        test: function (value) {
 
          return value?.length == 14 && isValidPhoneNumber(value);
        },
      }),
    otherwise: yup.string(),
  }),
  coMaritalStatus: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Marital Status is required"),
    otherwise: yup.string(),
  }),

  address: yup
    .string()
    .min(10, "Address must be atleast 10 characters")
    .required("Address is required"),
  state: yup.string().required("State is required"),
  lga: yup.string().nullable().required("LGA is required"),
  city: yup.string().required("City is required"),
  residentialStatus: yup.string().required("Residential status is required"),
  residenceSince: yup.string().required("Residential since is required").nullable(),

  emergencyContact1LastName: yup.string().required("Last name is required"),
  emergencyContact1FirstName: yup.string().required("First name is required"),
  emergencyContact1Address: yup
    .string()
    .min(10, "Address must be atleast 10 characters")
    .required("Address is required"),
  emergencyContact1State: yup.string().required("State is required"),
  emergencyContact1Lga: yup.string().nullable().required("LGA is required"),
  emergencyContact1City: yup.string().required("City is required"),
  emergencyContact1Phone: yup
    .string()

    .required("Phone Number is required").test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {

        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),

  emergencyContact2LastName: yup.string().required("Last name is required"),
  emergencyContact2FirstName: yup
    .string()
    // .notOneOf(
    //   [yup.ref("emergencyContact1FirstName"), null],
    //   "First name must be different from Emergency contact 1"
    // )
    .required("First name is required"),
  emergencyContact2Address: yup
    .string()
    .min(10, "Address must be atleast 10 characters")
    .required("Address is required"),
  emergencyContact2State: yup.string().required("State is required"),
  emergencyContact2Lga: yup.string().nullable().required("LGA is required"),
  emergencyContact2City: yup.string().required("City is required"),
  emergencyContact2Phone: yup
    .string()

    .notOneOf(
      [yup.ref("emergencyContact1Phone"), null],
      "Phone number must be different from Emergency contact 1"
    ).required("Phone number is required").test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {
        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),

  employerName: yup.string().required("Employer's name is required"),
  // employerScheme: yup.string().required("scheme name is required"),
  employerIndustry: yup.string().required("Industry name is required"),
  employerOccupation: yup.string().required("Occupation is required"),
  // employerType: yup.string().required("Employer type is required"),
  employerPhone: yup
    .string()

    .required("Phone number is required").test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {
        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),
  employerAddress: yup
    .string()
    .min(10, "Address must be atleast 10 characters")
    .required("Address is required"),
  employerState: yup.string().required("State is required"),
  employerLga: yup.string().nullable().required("LGA is required"),
  employerCity: yup.string().required("City is required"),
  employmentDate: yup.string().required("Employment Date is required").nullable(),

  rsaEquityContribution: yup
    .string()
    .nullable()
    .required("please select an option"),
  foundProperty: yup.string().nullable().required("please select an option"),
  haveBankAccount: yup.string().nullable().required("please select an option"),
  accountCreationConsent: yup.bool().when("haveBankAccount", {
    is: "false",
    then: yup.bool().oneOf([true], "Field must be checked"),
    otherwise: yup.bool(),
  }),

  pfa: yup.string().when("rsaEquityContribution", {
    is: "true",
    then: yup.string().required("PFA is required"),
    otherwise: yup.string(),
  }),
  rsaPin: yup.string().when("rsaEquityContribution", {
    is: "true",
    then: yup.string().required("RSA pin is required"),
    otherwise: yup.string(),
  }),

  bankAccount: yup.string().when("haveBankAccount", {
    is: "true",
    then: yup.string().required("Bank account is required"),
    otherwise: yup.string(),
  }),

  propertyIdentifier: yup.string(),
  propertyType: yup.string().required("Property type is required"),
  propertyPrice: yup.string().required("Property Price is required"),
  propertyEquityContribution: yup
    .string()
    .test({
      name: "min",
      message:
        "Property Equity Contribution must not be less than 20% of property price",
      test: function (value) {
        return value >= parseFloat(0.2 * this.parent.propertyPrice);
      },
    })
    .test({
      name: "max",
      message:
        "Property Equity Contribution must not be greater than property price",
      test: function (value) {
        return value <= parseFloat(this.parent.propertyPrice);
      },
    })
    .required("Property Equity Contribution is required"),
  propertyAddress: yup
    .string()
    .min(10, "Address must be atleast 10 characters")
    .required("Property's Address is required"),
  propertyState: yup.string().required("State is required"),
  propertyLga: yup.string().nullable().required("LGA is required"),
  propertyCity: yup.string().required("City is required"),
  customerDeclarationStatement: yup
    .bool()
    .oneOf([true], "Field must be checked"),

  signDate: yup.string().required("Date is required").nullable(),
  signature: yup.string().required("Signature or Full name is required").nullable(),
  signatureName: yup.string().required("Fullname or Signature is required"),
  
  coSignDate: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Date is required").nullable(),
    otherwise: yup.string().nullable(),
  }),
  coSignature: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Signature is required").nullable(),
    otherwise: yup.string(),
  }),
  coSignatureName: yup.string().when("category", {
    is: "joint",
    then: yup.string().required("Fullname or Signature is required"),
    otherwise: yup.string(),
  }),
});

export const creditCheckSchema = yup.object().shape({
  bvn: yup
    .string()
    .required("BVN is required")
    .min(11, "BVN must be 11 characters")
    .max(11, "BVN must be 11 characters")
    ,
  dob: yup.string().required("Date is required").nullable(),
});

export const signatureFieldSchema = yup.object().shape({
  fullname: yup.string().required("Full name is required"),
});